import * as UpdateProjectTypes from 'src/actions/project/update/Types';
import { UpdateProjectAction } from 'src/actions/project/update/UpdateProject.actions';

export interface UpdateProjectState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateProjectState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateProjectReducer(state: UpdateProjectState = initialState,
                                     action: UpdateProjectAction): UpdateProjectState {
  switch (action.type) {
    case UpdateProjectTypes.UPDATE_PROJECT_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateProjectTypes.UPDATE_PROJECT_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateProjectTypes.UPDATE_PROJECT_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/UpdateProjectReducer.tsx